import { render, staticRenderFns } from "./65.vue?vue&type=template&id=12b8ab74&scoped=true&"
var script = {}
import style0 from "./65.vue?vue&type=style&index=0&id=12b8ab74&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12b8ab74",
  null
  
)

export default component.exports